import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JL } from 'jsnlog';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { TableConfiguration } from './shared/table/table-configuration';
import { provideTable } from '@tarktech/tark-ng-utils/table/provideTable';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ApiInterceptor } from './shared/interceptors/api-interceptor';
import { EtagInterceptor } from './shared/interceptors/etag.interceptor';
import { ApplicationStateService } from './shared/services/application-state.service';
import { GlobalErrorHandler } from './GlobalErrorHandler';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { jwtOptionsFactory } from './shared/auth/factories/jwtOptionsFactory';
import { TokenService } from './shared/auth/services/token.service';
import { provideNgIdle } from '@ng-idle/core';
import { NgxMaskPipe, provideEnvironmentNgxMask  } from 'ngx-mask';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe, SlicePipe } from '@angular/common';
import { LOCAL_PROVIDER } from '@tarktech/tark-ng-utils/table/service/tark-local-provider.service';
import { LocalProvider } from './shared/services/local-provider.service';
import { TarkCurrencyPipe, TarkDatePipe, TarkDateTimePipe, TarkTimePipe } from '@tarktech/tark-ng-utils';
import { FilteredProductPipe } from './make-table/pipes/filtered-product';
import { PhoneMaskPipe } from './shared/pipes/phone-mask.pipe';
import { FilterOrderItemsForStatusDetailScreenPipe } from './status-details-screen/pipe/filter-order-items-for-status-detail-screen.pipe';
import { DeactivateGuard } from './shared/guards/deactivate.guard';
import { providePrimeNG } from 'primeng/config';
import { LaraSagaBluePreset } from './lara-saga-blue-preset';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DataFilterComponent } from './shared/components/filter/dataFilter';
import { provideHighcharts } from 'highcharts-angular';
import { initializeUserDataFactory } from './app-initializers/InitializeUserDataFactory';
import { disableNumberInputSteppingFactory } from './app-initializers/DisableNumberInputSteppingFactory';
import { HIGHCHARTS_OPTIONS } from './highcharts-style-options';

const PROVIDED_PIPES=[
    NgxMaskPipe,
    DecimalPipe,
    DatePipe,
    TarkTimePipe,
    SlicePipe,
    TarkDateTimePipe,
    CurrencyPipe,
    FilteredProductPipe,
    TarkDatePipe,
    PhoneMaskPipe,
    TarkCurrencyPipe,
    FilterOrderItemsForStatusDetailScreenPipe,
    DataFilterComponent
]

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAppInitializer(initializeUserDataFactory),
    provideAppInitializer(disableNumberInputSteppingFactory),
    DeactivateGuard,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: LaraSagaBluePreset,
        options:{
          darkModeSelector: false
        }
      },
      zIndex: {
        modal: 1100,
        overlay: 1000,
        menu: 1050,
        tooltip: 1100
      }
    }),
    provideHighcharts({
      options:HIGHCHARTS_OPTIONS
    }),
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true, deps: [ApplicationStateService] },
    { provide: HTTP_INTERCEPTORS, useClass: EtagInterceptor, multi: true, deps: [ApplicationStateService] },
    provideTable(TableConfiguration),
    { provide: 'JSNLOG', useValue: JL},
    { provide: BsModalRef, useClass: BsModalRef },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' }
    },
    { provide: LOCAL_PROVIDER, useExisting: LocalProvider },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '../assets/i18n/',
        suffix: '.json'
      })
    }),
    importProvidersFrom(JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [TokenService]
      }
    })),
    importProvidersFrom(LoggerModule.forRoot({serverLoggingUrl: '/api/logs', level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR})),
    importProvidersFrom(
      ToastNoAnimationModule.forRoot({
        closeButton: true,
        timeOut: 10000
      })
    ),
    importProvidersFrom(ModalModule.forRoot()),
    provideNgIdle(),
    CookieService,
    BsModalService,
      provideEnvironmentNgxMask(),
    ...PROVIDED_PIPES,
    CommonModule,
    // ------------------------------------------------------------
    // // these can be moved to component files as per need
    // ------------------------------------------------------------
    // importProvidersFrom(TooltipModule.forRoot()),
    // importProvidersFrom(BsDropdownModule.forRoot()),
    // importProvidersFrom(PopoverModule.forRoot()),
    // NgxMaskDirective,
    // NgPipesModule,
    // ------------------------------------------------------------
  ]
};
